import { Paragraph, tokens } from '@welbe/web-design-system';
import { MdInfo } from 'react-icons/md';
import { Wrapper } from './Alert.styles';

type AlertProps = {
	text: string;
};

export const Alert = ({ text }: AlertProps): JSX.Element => {
	return (
		<Wrapper>
			<MdInfo color={tokens.color_primary} fontSize={20} />
			<Paragraph fontWeight="500" fontSize="12px">
				{text}
			</Paragraph>
		</Wrapper>
	);
};
